// v109.9.136 — Small badge showing leave-request state (Submitted /
// Approved / Rejected) plus an Emergency chip. Rendered next to any
// attendance cell that has an associated leave_request.
import React from "react";

const STATE_CLS = {
  Approved: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-500/20 dark:text-emerald-200 dark:border-emerald-500/40",
  Submitted: "bg-amber-100 text-amber-800 border-amber-300 dark:bg-amber-500/20 dark:text-amber-100 dark:border-amber-500/40",
  Rejected: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-500/20 dark:text-rose-100 dark:border-rose-500/40",
};

/**
 * Props (all optional — component renders nothing if `state` is falsy):
 *   state              "Approved" | "Submitted" | "Rejected"
 *   emergency          boolean
 *   autoGenerated      boolean (tag "Auto")
 *   autoConvertedLwp   boolean (tag "→ LWP")
 *   className          extra classes
 */
export default function LeaveStateTag({
  state, emergency, autoGenerated, autoConvertedLwp, className = "",
  compact = false,
}) {
  if (!state) return null;
  const base = "inline-flex items-center gap-0.5 rounded border font-semibold uppercase tracking-wide";
  const pad = compact ? "px-1 py-0 text-[8.5px]" : "px-1.5 py-0.5 text-[9.5px]";
  return (
    <span className={`inline-flex flex-wrap items-center gap-0.5 ${className}`} data-testid="leave-state-tag">
      <span className={`${base} ${pad} ${STATE_CLS[state] || STATE_CLS.Submitted}`}>{state}</span>
      {emergency && (
        <span className={`${base} ${pad} bg-rose-600 text-white border-rose-700`}>Emergency</span>
      )}
      {autoGenerated && (
        <span className={`${base} ${pad} bg-slate-500 text-white border-slate-600`}>Auto</span>
      )}
      {autoConvertedLwp && (
        <span className={`${base} ${pad} bg-orange-500 text-white border-orange-600`}>→ LWP</span>
      )}
    </span>
  );
}
